const EmbaixadoresIconBranco = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 481.44 426.9">
      <path
        className="embbcls-1"
        d="M182.05,605.83H63V178.93H212.25l91.06,238.92,89.26-238.92H544.49v426.9H426.83c5.15-30.12-1.12-58.39-20.74-84.52l16.68-70.55c16.09,8.86,26.06,9.53,30.43,2.7,6.54-27-31.61-43.95-44.46-35.16-5.22,3-13.69,45.53-25.41,78.21-46.88-32.68-109-38.06-157.78,2.26L198.06,384.49c-6.32-18.71-32.77-9.81-46.11,3.07-9,8.65-13.43,19.7-4.38,28.26,7.85,7.43,20.85,6.43,32.45-9.47l22.32,115C185.22,544,180.76,573.42,182.05,605.83Z"
        transform="translate(-63.04 -178.93)"
      />
      <path
        className="embbcls-2"
        d="M207.72,532.83c30.9-3.7,60-5.19,84.41-.79,1.94-3.28,5.49-5.59,12.17-6,8.09-.74,11.69,1.87,13.3,6,25.53-3.88,55-2.89,86.6.67h0a20,20,0,0,0-1.32,4.43c-2.26,13.4-8.86,23-24.2,25.33-26.06,5.23-45.66,2.35-55.5-12.82a31.28,31.28,0,0,1-1.57-2.83c-8.38-16.42-15.43-14-15.76-13.93-2.87.45-5.8-1-14.7,13.31a30.88,30.88,0,0,1-8.2,8.91c-12.45,8.8-29.25,10.89-47.84,7.36-13.3-1.69-24-9.59-27.05-27.81Z"
        transform="translate(-63.04 -178.93)"
      />
      <path
        className="embbcls-3"
        d="M230.88,541.51,256,558c2.12,1.57,4.61-2.07,2.2-4.14l-24.34-16.23C231,536.14,228.6,539.31,230.88,541.51Z"
        transform="translate(-63.04 -178.93)"
      />
      <path
        className="embbcls-3"
        d="M250.48,539l19.36,12.43c1.63,1.18,3.55-1.56,1.69-3.12l-18.77-12.24C250.54,535,248.72,537.37,250.48,539Z"
        transform="translate(-63.04 -178.93)"
      />
      <path
        className="embbcls-3"
        d="M338.53,541.51,363.63,558c2.12,1.57,4.61-2.07,2.2-4.14l-24.34-16.23C338.62,536.14,336.25,539.31,338.53,541.51Z"
        transform="translate(-63.04 -178.93)"
      />
      <path
        className="embbcls-3"
        d="M358.13,539l19.36,12.43c1.63,1.18,3.55-1.56,1.7-3.12l-18.78-12.24C358.19,535,356.37,537.37,358.13,539Z"
        transform="translate(-63.04 -178.93)"
      />
    </svg>
  );
};

export default EmbaixadoresIconBranco;
